import React from 'react';
import PropTypes from 'prop-types';
import Link from '@sportson/core-web/components/Link';
import Button from 'components/Button';
import styled from 'libs/styled';
import Arrow from 'assets/media/icons/Arrow';

const StyledButton = styled(Button)`
    display: flex;
    height: 40px;
    width: 40px;
    min-width: 40px;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--color-neutrals-200);
    border-radius: 50%;
    pointer-events: none;

    &[data-is-active='true'] {
        pointer-events: auto;
    }
`;

const PaginationButton = ({ arrowSize, size, direction, to, active, ...rest }) => (
    <StyledButton as={to ? Link : 'button'} to={to} data-is-active={active} {...rest}>
        <Arrow direction={direction} width={arrowSize} height={arrowSize} />
    </StyledButton>
);

const responsivePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);

PaginationButton.propTypes = {
    active: PropTypes.bool,
    arrowSize: responsivePropType,
    direction: PropTypes.string,
    size: responsivePropType,
    to: PropTypes.string,
};

PaginationButton.defaultProps = {
    active: false,
    arrowSize: '15px',
    direction: 'left',
    size: '40px',
    to: null,
};

export default PaginationButton;
